import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["select", "customContainer"]
  }

  toggleCustomIfNeeded() {
    let selectedValue = this.selectTarget.value

    if (selectedValue === "custom") {
      this.customContainerTarget.classList.remove("d-none")
    } else {
      this.customContainerTarget.classList.add("d-none")
    }
  }
}
